import { observer } from 'mobx-react'
import cx from 'classnames'

interface ChipProps {
  status?: 'error' | 'success' | 'warning'
  text: string
}

const Chip = ({ status, text }: ChipProps) => {
  return (
    <div className={cx('chip', status)}>
      <span className="chip-text">{text}</span>
    </div>
  )
}

export default observer(Chip)
